import type { ComponentContentSchema } from '@vibesites/runtime';
import { useContentToken, EditableToken } from '@vibesites/runtime/react';

function toEmbedUrl(raw: string): string {
  const url = raw.trim();
  const vimeo = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}`;
  const youtube = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([A-Za-z0-9_-]+)/);
  if (youtube) return `https://www.youtube.com/embed/${youtube[1]}`;
  return url;
}

export function VideoTourEmbed() {
  const url = useContentToken('videotourembed.url');
  const embedUrl = url ? toEmbedUrl(url) : '';

  return (
    <section className="bg-white py-8 md:py-12">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <EditableToken path="videotourembed.url" as="div" className="w-full">
          <div
            className="relative w-full overflow-hidden rounded-lg border border-[var(--vibe-color-border)]"
            style={{ paddingBottom: '56.25%' }}
          >
            {embedUrl ? (
              <iframe
                src={embedUrl}
                className="absolute inset-0 h-full w-full border-0"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                title="Video Tour"
              />
            ) : (
              <div className="absolute inset-0 flex items-center justify-center bg-[var(--vibe-color-surface)]">
                <p className="font-body text-[var(--vibe-color-text-muted)]">
                  No video tour is available for this property.
                </p>
              </div>
            )}
          </div>
        </EditableToken>
      </div>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'VideoTourEmbed',
  displayName: 'Video Tour',
  tokens: {
    'videotourembed.url': {
      label: 'Video URL',
      type: 'url',
      defaultValue: 'https://player.vimeo.com/video/465105687',
    },
  },
};

(VideoTourEmbed as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default VideoTourEmbed;
